import FilterIcon from '@atlaskit/icon/core/migration/filter';
import IssuesIcon from '@atlaskit/icon/core/migration/work-items--issues';
import LabelIcon from '@atlaskit/icon/core/migration/tag--label';
import TeamsIcon from '@atlaskit/icon/core/migration/teams';
import ProjectIcon from '@atlaskit/icon/core/project';
import { expVal } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';
import type { IntlShape } from '@atlassian/jira-intl';
import { BOARD_SOURCE_FIELDS } from '../../../../common/constants.tsx';
import type { SourceTypeOptionGroup } from '../../../../common/types.tsx';
import messages from './messages.tsx';

export const getOptionGroups = ({
	formatMessage,
	projectAvatar,
}: {
	formatMessage: IntlShape['formatMessage'];
	projectAvatar?: string;
}): SourceTypeOptionGroup[] => {
	const allIssuesFromProjectSelectedTitleIssueTerminologyRefreshM4Replacement = expVal(
		'project-terminology-refresh',
		'isEnabled',
		false,
	)
		? messages.allIssuesFromProjectSelectedTitleIssueTerminologyRefreshM4Galaxia
		: messages.allIssuesFromProjectSelectedTitleIssueTerminologyRefreshM4;
	const allIssuesFromProjectTitleIssueTerminologyRefreshM4Replacement = expVal(
		'project-terminology-refresh',
		'isEnabled',
		false,
	)
		? messages.allIssuesFromProjectTitleIssueTerminologyRefreshM4Galaxia
		: messages.allIssuesFromProjectTitleIssueTerminologyRefreshM4;
	const allIssuesFromProjectTitleMessage = fg('jira-issue-terminology-update-m4')
		? allIssuesFromProjectTitleIssueTerminologyRefreshM4Replacement
		: messages.allIssuesFromProjectTitle;
	const allIssuesFromProjectSelectedTitleMessage = fg('jira-issue-terminology-update-m4')
		? allIssuesFromProjectSelectedTitleIssueTerminologyRefreshM4Replacement
		: messages.allIssuesFromProjectSelectedTitle;
	const teamSelectedTitleMessage = fg('jira-issue-terminology-update-m4')
		? messages.teamSelectedTitleIssueTerminologyRefreshM4
		: messages.teamSelectedTitle;
	const teamDescriptionMessage = fg('jira-issue-terminology-update-m4')
		? messages.teamDescriptionIssueTerminologyRefreshM4
		: messages.teamDescription;
	const issueTypesTitleMessage = fg('jira-issue-terminology-update-m4')
		? messages.issueTypesTitleIssueTerminologyRefreshM4
		: messages.issueTypesTitle;
	const issueTypesSelectedTitleMessage = fg('jira-issue-terminology-update-m4')
		? messages.issueTypesSelectedTitleIssueTerminologyRefreshM4
		: messages.issueTypesSelectedTitle;
	const issueTypesDescriptionMessage = fg('jira-issue-terminology-update-m4')
		? messages.issueTypesDescriptionIssueTerminologyRefreshM4
		: messages.issueTypesDescription;
	const labelsSelectedTitleMessage = fg('jira-issue-terminology-update-m4')
		? messages.labelsSelectedTitleIssueTerminologyRefreshM4
		: messages.labelsSelectedTitle;
	const labelsDescriptionMessage = fg('jira-issue-terminology-update-m4')
		? messages.labelsDescriptionIssueTerminologyRefreshM4
		: messages.labelsDescription;
	const savedFilterSelectedTitleMessage = fg('jira-issue-terminology-update-m4')
		? messages.savedFilterSelectedTitleIssueTerminologyRefreshM4
		: messages.savedFilterSelectedTitle;
	const savedFilterDescriptionMessage = fg('jira-issue-terminology-update-m4')
		? messages.savedFilterDescriptionIssueTerminologyRefreshM4
		: messages.savedFilterDescription;
	return [
		{
			options: [
				{
					label: formatMessage(allIssuesFromProjectTitleMessage),
					title: formatMessage(allIssuesFromProjectTitleMessage),
					selectedTitle: allIssuesFromProjectSelectedTitleMessage,
					value: null,
					icon: projectAvatar || ProjectIcon,
				},
			],
		},
		{
			options: [
				{
					label: formatMessage(messages.teamTitle),
					title: formatMessage(messages.teamTitle),
					selectedTitle: teamSelectedTitleMessage,
					description: formatMessage(teamDescriptionMessage),
					value: BOARD_SOURCE_FIELDS.TEAM,
					icon: TeamsIcon,
				},
				{
					label: formatMessage(issueTypesTitleMessage),
					title: formatMessage(issueTypesTitleMessage),
					selectedTitle: issueTypesSelectedTitleMessage,
					description: formatMessage(issueTypesDescriptionMessage),
					value: BOARD_SOURCE_FIELDS.ISSUE_TYPES,
					icon: IssuesIcon,
				},
				{
					label: formatMessage(messages.labelsTitle),
					title: formatMessage(messages.labelsTitle),
					selectedTitle: labelsSelectedTitleMessage,
					description: formatMessage(labelsDescriptionMessage),
					value: BOARD_SOURCE_FIELDS.LABELS,
					icon: LabelIcon,
				},
			],
		},
		{
			options: [
				{
					label: formatMessage(messages.savedFilterTitle),
					title: formatMessage(messages.savedFilterTitle),
					selectedTitle: savedFilterSelectedTitleMessage,
					description: formatMessage(savedFilterDescriptionMessage),
					value: BOARD_SOURCE_FIELDS.SAVED_FILTER,
					icon: FilterIcon,
				},
			],
		},
	];
};
